import React from "react";

import Plot from "react-plotly.js";
import { withSize } from "react-sizeme";

const PieChart = ({ data, layout, size: { width, height } }) => {
  return (
    <Plot
      data={data}
      style={{ height: "100%", width: "95%" }}
      layout={{
        ...layout,
        autosize: true,
        height: 220,
        width,
      }}
    />
  );
};

export default withSize()(PieChart);
